const MLA = `<?xml version="1.0" encoding="utf-8"?>
<style xmlns="http://purl.org/net/xbiblio/csl" class="in-text" version="1.0" demote-non-dropping-particle="never" page-range-format="minimal-two">
  <info>
    <title>Modern Language Association 8th edition</title>
    <title-short>MLA</title-short>
    <id>http://www.zotero.org/styles/modern-language-association</id>
    <link href="http://www.zotero.org/styles/modern-language-association" rel="self"/>
    <link href="http://style.mla.org" rel="documentation"/>
    <author>
      <name>Sebastian Karcher</name>
    </author>
    <category citation-format="author"/>
    <category field="generic-base"/>
    <summary>This style adheres to the MLA 8th edition handbook. Follows the structure of references as outlined in the MLA Manual closely</summary>
    <updated>2019-05-08T12:24:56+00:00</updated>
    <rights license="http://creativecommons.org/licenses/by-sa/3.0/">This work is licensed under a Creative Commons Attribution-ShareAlike 3.0 License</rights>
  </info>
  <locale xml:lang="en">
    <date form="text">
      <date-part name="day" suffix=" "/>
      <date-part name="month" suffix=" " form="short"/>
      <date-part name="year"/>
    </date>
    <terms>
      <term name="month-01" form="short">Jan.</term>
      <term name="month-02" form="short">Feb.</term>
      <term name="month-03" form="short">Mar.</term>
      <term name="month-04" form="short">Apr.</term>
      <term name="month-05" form="short">May</term>
      <term name="month-06" form="short">June</term>
      <term name="month-07" form="short">July</term>
      <term name="month-08" form="short">Aug.</term>
      <term name="month-09" form="short">Sept.</term>
      <term name="month-10" form="short">Oct.</term>
      <term name="month-11" form="short">Nov.</term>
      <term name="month-12" form="short">Dec.</term>
      <term name="translator" form="short">trans.</term>
    </terms>
  </locale>
  <macro name="author">
    <names variable="author">
      <name name-as-sort-order="first" and="text" delimiter-precedes-last="always" delimiter-precedes-et-al="always" initialize="false" initialize-with=". "/>
      <label form="long" prefix=", "/>
      <substitute>
        <names variable="editor"/>
        <names variable="translator"/>
        <text macro="title"/>
      </substitute>
    </names>
  </macro>
  <macro name="author-short">
    <group delimiter=", ">
      <names variable="author">
        <name form="short" initialize-with=". " and="text"/>
        <substitute>
          <names variable="editor"/>
          <names variable="translator"/>
          <text macro="title-short"/>
        </substitute>
      </names>
      <choose>
        <if disambiguate="true">
          <text macro="title-short"/>
        </if>
      </choose>
    </group>
  </macro>
  <macro name="title">
    <choose>
      <if variable="container-title" match="any">
        <text variable="title" quotes="true" text-case="title"/>
      </if>
      <else>
        <text variable="title" font-style="italic" text-case="title"/>
      </else>
    </choose>
  </macro>
  <macro name="title-short">
    <choose>
      <if variable="container-title" match="any">
        <text variable="title" form="short" quotes="true" text-case="title"/>
      </if>
      <else>
        <text variable="title" form="short" font-style="italic" text-case="title"/>
      </else>
    </choose>
  </macro>
  <macro name="container-title">
    <text variable="container-title" font-style="italic" text-case="title"/>
  </macro>
  <macro name="other-contributors">
    <group delimiter=", ">
      <choose>
        <if variable="container-title" match="any">
          <names variable="illustrator interviewer editor translator" delimiter=", ">
            <label form="verb" suffix=" "/>
            <name and="text"/>
          </names>
        </if>
        <else>
          <names variable="illustrator interviewer editor translator" delimiter=", ">
            <label form="verb" suffix=" " text-case="capitalize-first"/>
            <name and="text"/>
          </names>
        </else>
      </choose>
      <names variable="director">
        <label form="verb" suffix=" " text-case="capitalize-first"/>
        <name and="text"/>
      </names>
    </group>
  </macro>
  <macro name="version">
    <group delimiter=", ">
      <choose>
        <if is-numeric="edition">
          <group delimiter=" ">
            <number variable="edition" form="ordinal"/>
            <text term="edition" form="short"/>
          </group>
        </if>
        <else>
          <text variable="edition" text-case="capitalize-first"/>
        </else>
      </choose>
      <text variable="version"/>
    </group>
  </macro>
  <macro name="number">
    <group delimiter=", ">
      <group>
        <choose>
          <!--lowercase if we have a preceding element-->
          <if variable="edition container-title" match="any">
            <group delimiter=" ">
              <text term="volume" form="short"/>
              <text variable="volume"/>
            </group>
          </if>
          <!--other contributors preceding the volume-->
          <else-if variable="author editor" match="all">
            <group delimiter=" ">
              <text term="volume" form="short"/>
              <text variable="volume"/>
            </group>
          </else-if>
          <else>
            <group delimiter=" ">
              <text term="volume" form="short" text-case="capitalize-first"/>
              <text variable="volume"/>
            </group>
          </else>
        </choose>
      </group>
      <group delimiter=" ">
        <text term="issue" form="short"/>
        <text variable="issue"/>
      </group>
      <choose>
        <if type="report">
          <text variable="genre"/>
        </if>
      </choose>
      <text variable="number"/>
    </group>
  </macro>
  <macro name="publisher">
    <text variable="publisher"/>
  </macro>
  <macro name="publication-date">
    <choose>
      <if type="book chapter paper-conference motion_picture" match="any">
        <date variable="issued" form="numeric" date-parts="year"/>
      </if>
      <else-if type="article-journal article-magazine" match="any">
        <date variable="issued" form="text" date-parts="year-month"/>
      </else-if>
      <else-if type="speech" match="none">
        <date variable="issued" form="text"/>
      </else-if>
    </choose>
  </macro>
  <macro name="location">
    <group delimiter=", ">
      <group delimiter=" ">
        <label variable="page" form="short"/>
        <text variable="page"/>
      </group>
      <choose>
        <if variable="source" match="none">
          <text macro="URI"/>
        </if>
      </choose>
    </group>
  </macro>
  <macro name="container2-title">
    <group delimiter=", ">
      <choose>
        <if type="speech">
          <text variable="event"/>
          <date variable="event-date" form="text"/>
          <text variable="event-place"/>
        </if>
      </choose>
      <text variable="archive"/>
      <text variable="archive-place"/>
      <text variable="archive_location"/>
    </group>
  </macro>
  <macro name="container2-location">
    <choose>
      <if variable="source">
        <choose>
          <if variable="DOI URL" match="any">
            <group delimiter=", ">
              <text variable="source" font-style="italic"/>
              <text macro="URI"/>
            </group>
          </if>
        </choose>
      </if>
    </choose>
  </macro>
  <macro name="URI">
    <choose>
      <if variable="DOI">
        <text variable="DOI" prefix="doi:"/>
      </if>
      <else>
        <text variable="URL"/>
      </else>
    </choose>
  </macro>
  <macro name="accessed">
    <!--using accessed where we don't have an issued date; follows recommendation on p. 53 -->
    <choose>
      <if variable="issued" match="none">
        <group delimiter=" ">
          <text term="accessed" text-case="capitalize-first"/>
          <date variable="accessed" form="text"/>
        </group>
      </if>
    </choose>
  </macro>
  <citation et-al-min="3" et-al-use-first="1" disambiguate-add-names="true" disambiguate-add-givenname="true">
    <layout prefix="(" suffix=")" delimiter="; ">
      <choose>
        <if locator="page line" match="any">
          <group delimiter=" ">
            <text macro="author-short"/>
            <text variable="locator"/>
          </group>
        </if>
        <else>
          <group delimiter=", ">
            <text macro="author-short"/>
            <group>
              <label variable="locator" form="short"/>
              <text variable="locator"/>
            </group>
          </group>
        </else>
      </choose>
    </layout>
  </citation>
  <bibliography hanging-indent="true" et-al-min="3" et-al-use-first="1" line-spacing="2" entry-spacing="0" subsequent-author-substitute="---">
    <sort>
      <key macro="author"/>
      <key variable="title"/>
    </sort>
    <layout suffix=".">
      <group delimiter=". ">
        <text macro="author"/>
        <text macro="title"/>
        <date variable="original-date" form="numeric" date-parts="year"/>
        <group delimiter=", ">
          <!---This group corresponds to MLA's "Container 1"-->
          <text macro="container-title"/>
          <text macro="other-contributors"/>
          <text macro="version"/>
          <text macro="number"/>
          <text macro="publisher"/>
          <text macro="publication-date"/>
          <text macro="location"/>
        </group>
        <group delimiter=", ">
          <!---This group corresponds to MLA's "Container 2"-->
          <!--currently just using this one for archival info-->
          <text macro="container2-title"/>
          <text macro="container2-location"/>
        </group>
        <text macro="accessed"/>
      </group>
    </layout>
  </bibliography>
</style>`;

export default MLA;
